import React from "react";
import { useState } from "react";
import logo from "..//assets/logo.png";
import { CiUser } from "react-icons/ci";
import icon from "..//assets/icon.png";
import icon1 from "..//assets/icon1.png";
import icon2 from "..//assets/icon2.png";
import icon3 from "..//assets/icon3.png";
import face from "..//assets/face.png";
import twit from "..//assets/video.png";
import { HiMenu, HiX } from "react-icons/hi";
import insta from "..//assets/insta.png";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import returnIcon from "../assets/icons/arrow-right-left.svg";
import shippingIcon from "../assets/icons/la--shipping-fast.svg";

// import bannerImage from './assets/banner.jpg';  // Logo image path
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function Blog() {
    return (
        <>
            <Header />
            <ContactSection />
            <Footer />
            {/* <AnimatedBoxes />  */}
        </>
    );
}

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-md">
            <div className="flex items-center justify-between px-4 py-4 lg:mx-20">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img src={logo} alt="Bestie" className="h-16" />
                </div>

                {/* Desktop Menu Section */}
                <nav className="hidden space-x-8 font-sans font-semibold text-xl lg:flex">
                    <a href="/" className="text-gray-700 hover:text-gray-900">
                        HOME
                    </a>
                    <a
                        href="/products"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        PRODUCTS
                    </a>
                    <a
                        href="/blog"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        BLOG
                    </a>
                    <a
                        href="/contact"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        CONTACT
                    </a>
                </nav>

                {/* Search Bar and Admin Section */}
                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="relative hidden">
                        <input
                            type="text"
                            placeholder="Search"
                            className="px-4 py-2 text-sm border border-gray-300 rounded-full outline-none max-sm:hidden max-md:hidden focus:ring-2 focus:ring-gray-500"
                        />
                        <button className="absolute right-2 top-2">
                            <svg
                                className="w-5 h-5 text-gray-500 max-sm:hidden max-md:hidden"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Admin Icon */}
                    <button>
                        <CiUser className="hidden" />
                    </button>

                    {/* Mobile Menu Toggle Button */}
                    <button onClick={toggleMenu} className="lg:hidden">
                        {/* Switch between menu icon and close icon */}
                        {isMenuOpen ? (
                            <HiX className="w-6 h-6 text-gray-700" /> // Close icon when menu is open
                        ) : (
                            <HiMenu className="w-6 h-6 text-gray-700" /> // Menu icon when menu is closed
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="absolute top-0 left-0 z-20 w-2/3 h-full p-6 bg-white shadow-lg lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="mb-8 text-gray-700 hover:text-gray-900"
                    >
                        <HiX className="w-8 h-8" />{" "}
                        {/* Close icon in the mobile menu */}
                    </button>
                    <nav className="flex flex-col space-y-4 font-sans font-semibold">
                        <a
                            href="/"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            HOME
                        </a>
                        <a
                            href="/products"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            PRODUCTS
                        </a>
                        <a
                            href="/blog"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            BLOG
                        </a>
                        <a
                            href="/contact"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            CONTACT
                        </a>
                    </nav>
                </div>
            )}
            <div className="border"></div>
        </header>
    );
}
function ContactSection() {
    return (
        <div className="grid grid-cols-1 gap-8 mx-2 md:mx-20 mt-10 md:grid-cols-2">
            {/* Left Column: Registered Office */}
            <div className="flex flex-col items-start p-4 border rounded shadow ">
                <h2 className="mb-4 text-2xl font-bold">Registered Office</h2>
                <p>
                    <strong>
                        BESTIE HYGIENE CARE PRIVATE LIMITED
                        <br />
                        RENUKA IMPEX
                    </strong>
                    <br />
                    No. 12, 1st cross, 11th block, Nisarga Orchids,
                    <br />
                    Nagarabhavi 2nd stage,
                    <br />
                    Bangalore – 560072
                    <br />
                    Phone: (+91) 8660110969
                </p>
                <br></br>
                <br></br>
                {/* Map Section */}
                <div className="w-full h-64 overflow-hidden border rounded-md shadow-sm">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.072850872825!2d77.5079968!3d12.9671901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3dd9249c60ab%3A0x6ec32173122a06f0!2sBestie!5e0!3m2!1sen!2sin!4v1734497125295!5m2!1sen!2sin"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="w-full h-full"
                    ></iframe>
                </div>
            </div>

            {/* Right Column: Contact Form */}
            <div className="flex flex-col p-4 font-sans font-medium border rounded shadow">
                <h2 className="mb-4 text-2xl font-bold">Leave Us a Message</h2>
                <form>
                    <div className="mb-4">
                        <label className="block mb-2" htmlFor="name">
                            Name
                        </label>
                        <input
                            type="text"
                            id="name"
                            className="w-full px-3 py-2 border rounded"
                            placeholder="Your Name"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block mb-2" htmlFor="email">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            className="w-full px-3 py-2 border rounded"
                            placeholder="Your Email"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block mb-2" htmlFor="subject">
                            Subject
                        </label>
                        <input
                            type="text"
                            id="subject"
                            className="w-full px-3 py-2 border rounded"
                            placeholder="Subject"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block mb-2" htmlFor="message">
                            Message
                        </label>
                        <textarea
                            id="message"
                            className="w-full px-3 py-2 border rounded"
                            rows="4"
                            placeholder="Your Message"
                            required
                        ></textarea>
                    </div>
                    <button
                        type="submit"
                        className="px-4 py-2 text-white bg-[#52B3A4] rounded hover:bg-[#52B3A4] "
                    >
                        Send Message
                    </button>
                </form>
            </div>
        </div>
    );
}

function Footer() {
    return (
        <div className=" footer w-full py-7 bg-[#FFB4703D]">
            {/* Logo Row */}
            <div className="flex items-center justify-center">
                <img src={logo} alt="Logo" className="w-32" />
            </div>

            {/* Columns Row */}
            <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-3">
                {/* Column 1 */}
                <div className="flex flex-col items-center">
                    <img
                        src={shippingIcon}
                        alt="Safe Shipping"
                        className="flex flex-row h-12 w-15"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Shipping All Over India
                    </h3>
                </div>

                {/* Column 2 */}
                {/* <div className="flex flex-col items-center">
          <img src={icon1} alt="Secure Payment" className="w-12 h-12" />
          <br></br>
          <h3 className="font-sans font-bold">Secure Payment</h3>
          <p className="font-sans font-normal ">Guaranteed safe checkout</p>
        </div> */}

                {/* Column 3 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon3}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Dedicated Customer Support
                    </h3>
                </div>

                {/* Column 4 */}
                <div className="flex flex-col items-center">
                    <img
                        src={returnIcon}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        Safe and quick delivery
                    </h3>
                </div>
            </div>

            {/* Social Media Row */}
            <div className="mt-6 text-center">
                <h3 className="font-sans font-bold">Follow Us</h3>
                <div className="flex justify-center mt-2 space-x-4">
                    <a
                        href="https://www.facebook.com/bestie.care.hygiene/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={face} alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.youtube.com/@BestieHygiene"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={twit} alt="youtube" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://www.instagram.com/bestie.hygienecare/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D# "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={insta} alt="Instagram" className="w-8 h-8" />
                    </a>
                </div>
            </div>

            {/* Copyright Row */}
            <div className="w-full mx-0 bg-[#52B3A4] py-4 mt-6 text-center text-white font-sans">
                <p>
                    &copy; {new Date().getFullYear()} Bestie care. All rights
                    reserved.
                </p>
            </div>
        </div>
    );
}

export default Blog;
